import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const ViewProfile = lazy(() => import('../../container/investor/profile/ViewProfile'));
const ProfileUpdate = lazy(() => import('../../container/investor/profile/ProfileUpdate'));

const profile = () => {
  return (
    <Routes>
      <Route path="view" element={<ViewProfile />} />
      <Route path="edit" element={<ProfileUpdate />} />
    </Routes>
  );
};

export default profile;
